const defaultVariableLabels: Record<string, string> = {
  // Nomes padronizados (português snake_case)
  nome_contraparte: 'Nome da contraparte',
  primeiro_nome_contraparte: 'Primeiro nome da contraparte',
  email_contraparte: 'E-mail da contraparte',
  telefone_contraparte: 'Telefone da contraparte',
  nome_fantasia: 'Nome fantasia',
  razao_social: 'Razão social',
  cnpj: 'CNPJ',
  telefone: 'Telefone',
  mensagem_cliente: 'Última mensagem do cliente',
  ultima_mensagem_bot: 'Última mensagem do agente',
  data_mensagem_cliente: 'Última mensagem do cliente (data)',
  data_ultima_mensagem_bot: 'Última mensagem do agente (data)',
  tipo_evento: 'Tipo de evento',
  valor_pretensao: 'Valor da pretensão',
  valor_piso: 'Valor piso',
  temperatura: 'Temperatura',
  modo_conversa: 'Modo da conversa',
  status_conversa: 'Status da conversa',

  // Aliases (backward compatibility)
  counterpartyName: 'Nome da contraparte',
  counterpartyFirstName: 'Primeiro nome da contraparte',
  counterpartyEmail: 'E-mail da contraparte',
  nomeFantasia: 'Nome fantasia',
  razaoSocial: 'Razão social',
  phone: 'Telefone',
  lastBotMessage: 'Última mensagem do agente',
  mensagem_cliente_at: 'Última mensagem do cliente (data)',
  lastBotMessageAt: 'Última mensagem do agente (data)',
  eventType: 'Tipo de evento',
  claimAmount: 'Valor da pretensão',
  heat: 'Temperatura',
};

const autoMappedNegotiacaoVariableKeys = new Set([
  // Nomes padronizados
  'contraparte_nome',
  'contraparte_primeiro_nome',
  'contraparte_telefone',
  'contraparte_email',
  'escritorio_nome_fantasia',
  'escritorio_razao_social',
  'escritorio_cnpj',
  'telefone_normalizado',
  'mensagem_cliente',
  'mensagem_bot',
  'mensagem_cliente_data',
  'mensagem_bot_data',
  'tipo_evento',
  'valor_pleiteado',
  'piso',
  'heat',

  // Aliases (backward compatibility)
  'nome',
  'nomeCompleto',
  'cpfCnpj',
  'whatsapp',
  'phone',
  'valorDivida',
  'valor',
  'claimAmount',
  'counterpartyName',
  'counterpartyFirstName',
  'counterpartyPhone',
  'counterpartyEmail',
  'nomeFantasia',
  'razaoSocial',
  'lastBotMessage',
  'mensagem_cliente_at',
  'lastBotMessageAt',
  'eventType',
]);

export const isAutoMappedNegotiacaoVariable = (name: string) => {
  return autoMappedNegotiacaoVariableKeys.has(name);
};

export const formatAgentVariableLabel = (name: string, description?: string | null) => {
  if (defaultVariableLabels[name]) {
    return defaultVariableLabels[name];
  }
  if (description) {
    return description;
  }
  const label = name
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
  return label.charAt(0).toUpperCase() + label.slice(1);
};

/**
 * Regra única de "parâmetro obrigatório do agente preenchido", a da negociação individual: vazio
 * é só `undefined`, `null` ou `''`. Espaços contam como preenchido; a simulação usa a mesma regra
 * porque o AC03 pede as mesmas validações da negociação individual. Parâmetro opcional sempre
 * passa.
 */
export const parametroObrigatorioPreenchido = (
  variavel: { required?: boolean },
  valor: unknown,
): boolean => !variavel.required || (valor !== undefined && valor !== null && valor !== '');
